import React from "react";
import "./RewardsTickHomePage.scss"
import HeaderText from "../components/Text/HeaderText";
import SubheaderText from "../components/Text/SubheaderText";
import tick from "../image/tick.svg"
import food from "../image/food.svg"
import shopping from "../image/shopping.svg"
import travel from "../image/travel.svg"
import more from "../image/more.svg"
import BenefitCard from "../components/Card/BenefitCard/BenefitCard";

const RewardsTickBenefitsPage = () => {
    const benefits = [
        "Over 10,000 partner merchants",
        "Average savings of 15% per purchase",
        "24/7 customer support",
        "Secure payment processing"
    ]
    const benefitCard = [
        {
            "icon": food,
            "header": "Food & Dining",
            "subheader": "Restaurants & delivery",
            "bgColor": "linear-gradient(135deg, #ECFDF5 0%, #F0FDFA 100%)",
            "iconBgColor": "#059669"
        },
        {
            "icon": shopping,
            "header": "Retail Shopping",
            "subheader": "Fashion & lifestyle",
            "bgColor": "linear-gradient(135deg, #EFF6FF 0%, #EEF2FF 100%)",
            "iconBgColor": "#2563EB"
        }, {
            "icon": travel,
            "header": "Travel",
            "subheader": "Hotels & flights",
            "bgColor": "linear-gradient(135deg, #FAF5FF 0%, #FDF2F8 100%)",
            "iconBgColor": "#9333EA"
        }, {
            "icon": more,
            "header": "And More",
            "subheader": "Entertainment & services",
            "bgColor": "linear-gradient(135deg, #FFF7ED 0%, #FEF2F2 100%)",
            "iconBgColor": "#EA580C"
        }
    ]
    return (
        <div className="RewardsTickBenefitsPage">
            <div className="RewardsTickBenefitsPage-inner">
                <div className="RewardsTickBenefitsPage-inner-left">
                    <HeaderText
                        text={"Key Benefits of the RewardsTick Network"} />
                    <div className="RewardsTickBenefitsPage-subheader">
                        <SubheaderText
                            text={"Join millions of satisfied customers who save money while shopping for their favorite products across thousands of partner stores."}
                        />
                    </div>
                    <div className="RewardsTickBenefitsPage-list">
                        {benefits.map((benefit, key) => {
                            return (
                                <div
                                    className="RewardsTickBenefitsPage-list-item"
                                    key={key}>
                                    <img alt="" src={tick} />
                                    {benefit}
                                </div>
                            )
                        })}
                    </div>

                </div>
                <div className="RewardsTickBenefitsPage-inner-right">
                    <div className="RewardsTickBenefitsPage-grid">
                        {benefitCard.map((benefit, key) => {
                            return (
                                <BenefitCard benefit={benefit} key={key} />
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default RewardsTickBenefitsPage